import { createContext, useContext } from 'react';

export interface AiToolsSectionRegistration {
  id: string;
  title: string;
}

export interface AiToolsContextValue {
  isAvailable: boolean;
  container: HTMLDivElement | null;
  registerSection: (section: AiToolsSectionRegistration) => () => void;
}

export const AiToolsContext = createContext<AiToolsContextValue>({
  isAvailable: false,
  container: null,
  registerSection: () => () => undefined,
});

export function useAiTools() {
  return useContext(AiToolsContext);
}
